import { dispatchTrackingEvent } from '@context/tracking/utils';

export const trackLoyaltyCTA = (
  eventName: 'register' | 'log_in' | 'change_settings'
) => {
  dispatchTrackingEvent({
    event: 'vip_overlay_cta',
    vip: {
      action: 'click_on_overlay',
      name: eventName,
    },
  });
};
